<template>
  <el-row>
    <el-col :span="8">
      <el-date-picker v-model="year" type="year" value-format="yyyy" default-value="1990">
      </el-date-picker
    ></el-col>
    <el-col :span="8" style="padding-left: 10px">
      <el-select v-model="month" id="month">
        <el-option
          v-for="item in monthList"
          :key="item"
          :value="item"
          :label="item"
        ></el-option> </el-select
    ></el-col>
    <el-col :span="8" style="padding-left: 10px"
      ><el-select v-model="day" id="day">
        <el-option
          v-for="item in dayList"
          :key="item"
          :value="item"
          :label="item"
        ></el-option> </el-select
    ></el-col>
  </el-row>
</template>
<script>
export default {
  name: "birthdayPicker",
  prop: ["value"],
  data() {
    return {
      year: "",
      month: "",
      day: "",
      monthList: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      dayList: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
    };
  },
  created() {
    if (this.value) {
      let [y, m, d] = this.value.split("-");
      this.year = y;
      this.month = m;
      this.day = d;
    } else {
      this.year = "";
      this.month = "";
      this.day = "";
    }
  },
  watch: {
    year(v) {
      // this.month = ''
      this.day = "";
      this.update();
      let m = document.querySelector("#month");
      m.click();
    },
    month(v) {
      this.getDays();
      this.day = "";
      this.update();
      let m = document.querySelector("#day");
      m.click();
    },
    day(v) {
      this.update();
    },
  },
  methods: {
    update() {
      let v = this.year + "-" + this.month + "-" + this.day;
      console.log(v);
      this.$emit("input", v);
    },
    getDays() {
      if (!this.year || !this.month) return;
      let days = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ];
      let m = new Date(this.year, this.month, 0);
      let n = m.getDate();
      this.dayList = days.slice(0, n);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/birthdayPicker/index.vue